import { gql } from '@apollo/client';
import KEY_SCHEDULED_ACTIVITY_SETTINGS from '../../fragments/keyboarding-scheduled-activity-settings';

const UPDATE_KEY_CLASSROOM_ASSESSMENTS_SETTING = gql`
  mutation updateKeyClassroomSettingAssessments(
    $data: UpdateKeyClassroomSettingScheduledActivityInput!
  ) {
    updateKeyClassroomSettingAssessments(data: $data) {
      ...BaseKeyScheduledActivitySettings
    }
  }
  ${KEY_SCHEDULED_ACTIVITY_SETTINGS}
`;

export default UPDATE_KEY_CLASSROOM_ASSESSMENTS_SETTING;
